export default "__VITE_ASSET__1072070b__"